// extracted by mini-css-extract-plugin
export default {"container":"ShareLinkInput_container__HUS1d","button":"ShareLinkInput_button__EYijL","inputGroupText":"ShareLinkInput_inputGroupText__ryWtn"};